import React, { useEffect, useState } from "react";
import { Placeholder } from "semantic-ui-react";
import { Routes, Route, Link, BrowserRouter } from "react-router-dom";
import {
  cargarCalificacionFinal,
  cargarDatosProceso,
  cargarOfficer,
  cargarParticipante,
} from "../../utils/Datos";

export const InformacionParticipanteProceso = ({
  idProcess,
  id_participant,
  mostrarTitulo=true
}) => {
  const [process, setprocess] = useState(null);
  const [participant, setparticipant] = useState(null);
  const [officer, setofficer] = useState(null);
  const [calificacionFinal, setcalificacionFinal] = useState(null);

  useEffect(() => {
    cargarDatosProceso(idProcess).then((proceso) => {
      console.log(proceso);
      setprocess(proceso);
    });
  }, [id_participant]);

  useEffect(() => {
    console.log("Informacion participante proceso " + id_participant);
    cargarParticipante(id_participant).then((participante) => {
      setparticipant(participante);
      cargarOfficer(participante.id_officer).then((funcionario) => {
        setofficer(funcionario);
      });
      cargarCalificacionFinal(id_participant).then((c) => {
        console.log(c);
        if (c.status == 200) {
          setcalificacionFinal(c.datos);
        }
      });
    });
  }, [id_participant]);

  return process !== null && officer !== null ? (
    <>
      <div className="row">
        {mostrarTitulo ? <div className="col-md-12 mb-2">
                <h2>INFORMACIÓN DEL FUNCIONARIO Y PROCESO</h2>
        </div> : <></>}
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4">
              <label>Nombre del proceso</label>
              <input
                className="form-control disabled"
                name="nombre_proceso"
                
                disabled="disabled"
                value={process.name}
              ></input>
            </div>
            <div className="col-md-4">
              <label>Año</label>
              <input
                className="form-control disabled"
                name="anno_proceso"
                
                disabled="disabled"
                value={process.yearProcess}
              ></input>
            </div>
            <div className="col-md-4">
              <label>Nombre del funcionario</label>
              <input
                className="form-control disabled"
                name="nombre_funcionario"
                
                disabled="disabled"
                value={officer.officerName}
              ></input>
            </div>
          </div>
          <div className="row mt-3">
            
            <div className="col-md-4">
              <label>Rut</label>
              <input
                className="form-control disabled"
                name="rut_funcionario"
                
                disabled="disabled"
                value={officer.officerRut}
              ></input>
            </div>

            <div className="col-md-4">
              <label>Cargo</label>
              <input
                className="form-control disabled"
                name="nombre_proceso"
                
                disabled="disabled"
                value={officer.name_profile}
              ></input>
            </div>

            <div className="col-md-4">
              <label>Grado</label>
              <input
                className="form-control disabled"
                name="nombre_proceso"
                
                disabled="disabled"
                value={officer.gradeOfficer}
              ></input>
            </div>
          </div>
          <div className="row mt-3">
         
            {calificacionFinal !== null && calificacionFinal.status ? (
              <div className="col-md-4">
                <label>&nbsp;</label>
                <br></br>
                <Link
                  to={`/verCalificacion/${calificacionFinal.datos.id_qualifications}`}
                  className="btn btn-primary btn-block"
                >
                  Ver calificación
                </Link>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <Placeholder></Placeholder>
  );
};
